import React from 'react'
import useUUID from './use-uuid'
import useOperation from './use-operation'

export default function useOnOperationData (callback, dependencies = []) {
  const [uuid] = useUUID()
  const operation = useOperation()

  const internalCallback = (data) => {
    if (typeof callback === 'function') {
      callback(data)
    }
  }

  React.useEffect(() => {
    operation.onData(uuid, internalCallback)

    return () => {
      operation.unsetOnDataCallback(uuid)
    }
  }, [operation, ...dependencies])
}
